export const api_header = () => {
    const token = useCookie("XSRF-TOKEN");
    const tokenValue = token?.value ? 'Bearer ' + token.value : ''

    return {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": tokenValue
    }
}